import Vue from "vue";

export function userTimezone(user){
	if( !user ){
		return Vue.moment.tz.guess();
	}
	return user.timezone || Vue.moment.tz.guess()
}

export function browserTimezone(){
	return Vue.moment.tz.guess()
}

export function timezoneMatches(user){
	return userTimezone(user) == Vue.moment.tz.guess();
}	

export function localDateTimeString(user, dateTime, string='LONG'){
	var timezone = Vue.moment.tz.guess();
	if( user ){
		timezone = user.timezone || Vue.moment.tz.guess()
	}
	if( !dateTime ){
		dateTime = new Date();
	}
	var format = string;
	if( string == "DATE"){
		format = "dddd, d MMMM YYYY"
	}
	if( string == "LONG"){
		format = "LLLL"
	}
	if( string == "SHORT"){
		format = "D/M/Y";
	}
	if( string == "TIME"){
		format = "h:mm a";
	}
	var t = Vue.moment(dateTime).tz(timezone).format(format);
	return t;
}

export function localDateTime(user, dateTime){
	var timezone = Vue.moment.tz.guess();
	if( user ){
		timezone = user.timezone || Vue.moment.tz.guess()
	}
	if( !dateTime ){
		dateTime = new Date();
	}
	var t = Vue.moment(dateTime).tz(timezone);
	return t;
}